var map = {
	"./afb-color.svg": 647,
	"./alb-color.svg": 648,
	"./all.svg": 649,
	"./amb-color.svg": 650,
	"./arg.svg": 651,
	"./aus.svg": 652,
	"./bank-icon.svg": 653,
	"./bankdemo-color.svg": 654,
	"./bel.svg": 655,
	"./bimb-color.svg": 656,
	"./bkr-color.svg": 657,
	"./bpay-color.svg": 658,
	"./bra.svg": 659,
	"./bsn-color.svg": 660,
	"./can.svg": 661,
	"./checked-blue.webp": 1639,
	"./checked-green.png": 662,
	"./checked-white.png": 663,
	"./cimb-color.svg": 664,
	"./cimb-icon.svg": 665,
	"./citi-color.svg": 666,
	"./cmr.svg": 667,
	"./crc.svg": 668,
	"./cro.svg": 669,
	"./den.svg": 670,
	"./ecu.svg": 671,
	"./eng.svg": 672,
	"./esp.svg": 673,
	"./fav-blue.svg": 674,
	"./fav-blue.webp": 1640,
	"./fav-gray.png": 675,
	"./fav-gray.svg": 676,
	"./fav-gray.webp": 1641,
	"./fav-icon-active.png": 677,
	"./fav-icon.png": 678,
	"./fav-red.png": 679,
	"./fra.svg": 680,
	"./game-icon.svg": 681,
	"./games-active-m.svg": 682,
	"./games-m.webp": 1642,
	"./ger.svg": 683,
	"./gha.svg": 684,
	"./gxbank-color.svg": 685,
	"./hlb-color.svg": 686,
	"./hlb-icon.svg": 687,
	"./hsbc-color.svg": 688,
	"./irn.svg": 689,
	"./jpn.svg": 690,
	"./kor.svg": 691,
	"./ksa.svg": 692,
	"./kwh-color.svg": 693,
	"./latest-icon-active.png": 694,
	"./latest-icon.png": 695,
	"./lc-active-m.svg": 696,
	"./lc-icon.svg": 697,
	"./lc-m.webp": 1643,
	"./lottery-active-m.svg": 698,
	"./lottery-icon.svg": 699,
	"./lottery-m.svg": 700,
	"./love.svg": 701,
	"./mar.svg": 702,
	"./mbb-color.svg": 703,
	"./mex.svg": 704,
	"./ned.svg": 705,
	"./ocbc-color.svg": 706,
	"./ocbc-icon.svg": 707,
	"./p2p-active-m.svg": 708,
	"./p2p-icon.svg": 709,
	"./p2p-m.svg": 710,
	"./pbb-color.svg": 711,
	"./pol.svg": 712,
	"./por.svg": 713,
	"./price-high.svg": 714,
	"./price-low.svg": 715,
	"./qat.svg": 716,
	"./rhb-color.svg": 717,
	"./rhb-icon.svg": 718,
	"./scb-color.svg": 719,
	"./sen.svg": 720,
	"./slot-active-m.svg": 721,
	"./slot-icon.svg": 722,
	"./slot-m.webp": 1644,
	"./sport-active-m.svg": 723,
	"./sport-m.webp": 1645,
	"./sports-icon.svg": 724,
	"./srb.svg": 725,
	"./star.svg": 726,
	"./sui.svg": 727,
	"./tng-color.svg": 728,
	"./trx-icon.svg": 729,
	"./trx.svg": 730,
	"./tun.svg": 731,
	"./uob-color.svg": 732,
	"./uru.svg": 733,
	"./usa.svg": 734,
	"./usdc.svg": 735,
	"./usdt.svg": 736,
	"./ustd-icon.svg": 737,
	"./wal.svg": 738,
	"./x33-logo-b.svg": 739,
	"./x33-square-icon.svg": 740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;